function update(code_input, outputRenderTag) {
  // console.log("---> tikzUpdate ", code_input, outputRenderTag);
  const output = document.getElementById(outputRenderTag);
  // console.log("output is -------> ", output);
  const s = document.createElement("script");
  s.setAttribute("type", "text/tikz");
  s.textContent = `
  ${code_input}
    `;
  function recursiveTikz(num) {
    try {
      console.log(num);
      process_tikz(s);
    } catch (error) {
      console.log("1 tikz error --> ", error);
      setTimeout(() => {
        console.log("Triggered recursive tikz in setTimeout");
        recursiveTikz(num + 1);
      }, 1000);
    }
  }
  if (output) {
    output.innerHTML = "";
    output.appendChild(s);
    recursiveTikz(1);
  }
}

function executeTikz(code_input, outputRenderTag) {
  const output = document.getElementById(outputRenderTag);
  const s = document.createElement("script");
  s.setAttribute("type", "text/tikz");
  s.textContent = `
  ${code_input}
    `;
  output.innerHTML = "";
  output.appendChild(s);
  process_tikz(s);
}
